<template>
  <div>
    <a-form
        :form="form"
        :label-col="{ span: 9 }"
        :wrapper-col="{ span: 7 }"
        @submit="submit"
    >
      <h3 style="text-align: center; margin-top: 48px">Urządzenie</h3>
      <a-form-item label="Adres MAC">
        <a-input
            placeholder="AA:BB:CC:DD:EE:FF"
            v-decorator="[
            'macAddress',
            {
              rules: [
                {
                  required: true,
                  message: 'Adres MAC jest wymagany!',
                }
              ],
            },
          ]"
            :maxLength="17"
        />
      </a-form-item>
      <a-form-item label="Adres IP">
        <a-input
            v-decorator="[
            'ipAddress',
            {
              rules: [
                {
                  required: true,
                  message: 'Adres IP jest wymagany!',
                }
              ],
            },
          ]"
            :maxLength="20"
            placeholder="np. 10.20.0.2"
        />
      </a-form-item>
    </a-form>

    <a-row style="text-align: center">
      <a-button style="margin-right: 24px" type="default" @click="back">
        <a-icon type="left"/>
        Wróć
      </a-button>
      <a-button
          :disabled="!isVerificationCompleted"
          type="primary"
          @click="submit"
      >
        Dalej
        <a-icon type="right"/>
      </a-button>
    </a-row>
  </div>
</template>

<script>

export default {
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this, {name: "coordinated"}),
    };
  },
  mounted() {
    let data = this.$store.getters["getDeviceData"];
    this.form.setFieldsValue({
      ipAddress: data.ipAddress,
      macAddress: data.macAddress
    });
  },
  methods: {
    submit: function () {
      this.form.validateFields((errors, values) => {
        if (!errors) {
          this.$store.commit("updateDeviceData", values);
          this.$emit("nextStep");
        }
      });
    },
    back: function () {
      this.$emit("prevStep");
    },
    setUniversity(value) {
      this.form.setFieldsValue({
        name: value,
      });
    },
  },
  computed: {
    isVerificationCompleted: function () {
      return true;
    },
  },
};
</script>
